module.exports = __webpack_public_path__ + "static/img/iconfont.da56d20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/content_font/iconfont.svg?t=1614850630108
// module id = 4g4g
// module chunks = 133